import React, { useEffect, useState, useRef } from 'react'
import Swal from 'sweetalert2';
import { addDoc, collection, doc, getDoc, getDocs, onSnapshot, orderBy, query, Timestamp, updateDoc, where } from 'firebase/firestore';
import { auth, db } from '../../firebase';
import "../../App.css";
import moment from 'moment';
import { useReactToPrint } from 'react-to-print';
import Menu from '../../panel/Menu';

function Dcrreport() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fethUsers()
        });
    });
    const printRef = useRef();
    const [loading, setloading] = useState(false);
    const [loadincount, setloadincount] = useState(true);
    const [userData, setUserData] = useState();
    const [reportDate, setreportDate] = useState(moment().format('YYYY-MM-DD'));
    const [bookingData, setbookingData] = useState([]);
    const [payhistory, setpayhistory] = useState([]);
    const [paymodes, setpaymodes] = useState([]);

    const [allllserviuceamount, setallllserviuceamount] = useState(0)
    const [allllroomamount, setallllroomamount] = useState(0)
    const [allllfoodamount, setallllfoodamount] = useState(0)
    const [alllltotalamount, setalllltotalamount] = useState(0)
    const [roomscount, setroomscount] = useState(0)
    const [todasypending, settodasypending] = useState(0)
    const [pendingReceived, setpendingReceived] = useState(0)
    const [alldaytotal, setalldaytotal] = useState(0)
    const [checkoutReceived, setcheckoutReceived] = useState(0)
    const [ReceivedPayment, setReceivedPayment] = useState(0)
    const [pendinRecieved, setpendinRecieved] = useState(0)



    const fethUsers = async () => {
        try {
            if (userData) {
                if (loadincount) {
                    const docRef = doc(db, "users", userData.uid)
                    const docSnap = await getDoc(docRef)
                    if (docSnap.exists()) {
                        setloadincount(false)
                    }

                }
            }
        } catch (error) {
            console.log(error);
        }
    }

    const getReport = async () => {
        if (!reportDate) {
            Toast.fire({ icon: "error", title: 'Please select From Date & To Date' });
            return;
        }

        setloading(false);
        setbookingData([]);
        setpaymodes([]);

        let fromDateObj = new Date(reportDate);
        fromDateObj.setHours(0, 0, 0, 0);
        const nextDay = new Date(fromDateObj);
        nextDay.setDate(nextDay.getDate() + 1);

        // Query payment history
        const q1 = query(
            collection(db, 'payhistory'),
            where('status', '==', 'Working'),
            where('createdAt', '>=', Timestamp.fromDate(fromDateObj)),
            where('createdAt', '<', Timestamp.fromDate(nextDay))
        );

        const payhistorySnapshot = await getDocs(q1);
        const paymentHistoryData = await Promise.all(payhistorySnapshot.docs.map(async (doc1) => {
            const data = doc1.data();
            const [paymode1Snap, paymode2Snap] = await Promise.all([
                getDoc(doc(db, "paymentmodes", data.paymode1)),
                getDoc(doc(db, "paymentmodes", data.paymode2))
            ]);
            const paymode1 = paymode1Snap.exists() ? paymode1Snap.data().paymode : "";
            const paymode2 = paymode2Snap.exists() ? paymode2Snap.data().paymode : "";
            const date = data.createdAt.toDate();
            const createdat = moment(date).format('DD-MM-YYYY HH:mm:ss'); // Format date

            return {
                id: doc1.id,
                data,
                paymode1,
                paymode2,
                amount1: data.amount1 || 0, // Amount associated with paymode1
                amount2: data.amount2 || 0, // Amount associated with paymode2
                createdat
            };
        }));

        const paymentModesTotals = {};

        // Query checkindetails for both 'Checkout' and 'Booked' statuses
        const checkinDetailsCheckoutQuery = query(
            collection(db, 'checkindetails'),
            where('status', '==', 'Checkout'),
            where('checkindate', '==', reportDate)
        );

        const checkinDetailsBookedQuery = query(
            collection(db, 'checkindetails'),
            where('status', '==', 'Booked'),
            where('checkindate', '==', reportDate)
        );

        // Fetch checkin details in parallel
        const [checkinDetailsCheckoutSnapshot, checkinDetailsBookedSnapshot] = await Promise.all([
            getDocs(checkinDetailsBookedQuery),
            getDocs(checkinDetailsCheckoutQuery),
        ]);

        // Combine data from both statuses and ensure uniqueness by bookingid
        const checkinDetailsData = [
            ...checkinDetailsCheckoutSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })),
            ...checkinDetailsBookedSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
        ];

        const uniqueCheckinDetails = Array.from(
            new Map(checkinDetailsData.map(item => [item.bookingid, item])).values()
        );

        const bookingIds = uniqueCheckinDetails.map(doc => doc.bookingid);
        if (bookingIds.length === 0) {
            console.log("No bookings found for the specified report date.");
            return;
        }

        function chunkArray(array, size) {
            const chunks = [];
            for (let i = 0; i < array.length; i += size) {
                chunks.push(array.slice(i, i + size));
            }
            return chunks;
        }

        const bookingIdChunks = chunkArray(bookingIds, 30);
        const bookingSnapshots = await Promise.all(
            bookingIdChunks.map(chunk => {
                const q = query(
                    collection(db, 'bookings'),
                    where('__name__', 'in', chunk)
                );
                return getDocs(q);
            })
        );

        // Combine all documents into one array
        const allBookingDocs = bookingSnapshots.flatMap(snapshot => snapshot.docs);

        const bookingsDataMap = allBookingDocs.reduce((acc, doc) => {
            acc[doc.id] = { id: doc.id, ...doc.data() };
            return acc;
        }, {});



        // Create a map of payment history by bookingId
        const paymentHistoryMap = paymentHistoryData.reduce((acc, pay) => {
            const bookingId = pay.data.bookingid;

            // Only consider this entry if bookingId exists in bookingsDataMap
            if (bookingsDataMap[bookingId]) {
                if (!acc[bookingId]) {
                    acc[bookingId] = [];
                }
                acc[bookingId].push(pay); // Store payment history related to bookingId
            }
            return acc;
        }, {});

        let allllroomamount = 0;
        let allllfoodamount = 0;
        let alllltotalamount = 0;
        let allllalltoal = 0;
        let allllpaidamount = 0;
        let allllserviceamount = 0;
        let allllpending = 0;
        let noofroomscount = 0;
        let todayspending = 0;
        let pendingReceived = 0;
        let pendingReceivedZeroList = []; // 🟢 Array to store bookings where PendingReceived1 == 0

        // Combine checkin details and booking data
        const combinedData = await Promise.all(
            uniqueCheckinDetails.map(async (checkinDetail) => {
                const bookingData = bookingsDataMap[checkinDetail.bookingid] || null;
                const roomamount = bookingData?.rooamount || 0;

                const date1 = moment(bookingData.checkindate, 'YYYY-MM-DD');
                const date2 = moment(reportDate, 'YYYY-MM-DD');

                let dayDifference = date2.diff(date1, 'days');
                if (dayDifference === 0) {
                    dayDifference = 1;
                }

                const serviceamount =
                    parseFloat(bookingData?.serviceamount) / parseFloat(bookingData.noofdays) || 0;

                const q = query(
                    collection(db, 'orders'),
                    where('status', '==', 'Bill Pending'),
                    where('orderdate', '==', reportDate),
                    where('bookingId', '==', checkinDetail.bookingid)
                );

                // Fetch documents and calculate the sum of totalamount (for food)
                const querySnapshot = await getDocs(q);
                let foodTotal = 0;
                querySnapshot.forEach((doc) => {
                    const data = doc.data();
                    foodTotal += data.totalamount || 0; // Ensure 'totalamount' exists
                });

                // Payment history calculation
                let paymentHistory = paymentHistoryMap[checkinDetail.bookingid] || [];
                let paidAmount = paymentHistory.reduce(
                    (sum, pay) => sum + pay.amount1 + pay.amount2,
                    0
                );

                let totalamount =
                    parseFloat(roomamount) + parseFloat(serviceamount) + parseFloat(foodTotal);
                let alltoal = parseFloat(totalamount) * parseFloat(dayDifference);
                let remaining = parseFloat(alltoal) - parseFloat(paidAmount);

                let newrem = parseFloat(totalamount) - parseFloat(paidAmount);
                if (parseFloat(newrem) > 0) {
                    todayspending = parseFloat(todayspending) + parseFloat(newrem);
                }

                allllroomamount = parseFloat(allllroomamount) + parseFloat(roomamount.toFixed(0));
                allllfoodamount = parseFloat(allllfoodamount) + parseFloat(foodTotal.toFixed(0));
                alllltotalamount = parseFloat(alllltotalamount) + parseFloat(totalamount.toFixed(0));
                allllalltoal = parseFloat(allllalltoal) + parseFloat(alltoal.toFixed(0));
                allllpaidamount = parseFloat(allllpaidamount) + parseFloat(paidAmount.toFixed(0));
                allllserviceamount =
                    parseFloat(allllserviceamount) + parseFloat(serviceamount.toFixed(0));
                allllpending = parseFloat(allllpending) + parseFloat(remaining.toFixed(0));
                noofroomscount = parseFloat(noofroomscount) + parseFloat(bookingData.rooms.length);

                // 🟢 Pending received calculation
                let pendingReceived1 = 0;
                if (paidAmount > 0) {
                    pendingReceived1 = parseFloat(paidAmount) - parseFloat(totalamount);
                    pendingReceived = parseFloat(pendingReceived) + parseFloat(pendingReceived1);
                }

                console.log(
                    'BookingID:', checkinDetail.bookingid,
                    'Customer Name:', bookingData?.customers.custname || 'N/A',
                    'PendingReceived1:', pendingReceived1
                );

                if (parseFloat(pendingReceived1) !== 0) {
                    pendingReceivedZeroList.push({
                        bookingid: checkinDetail.bookingid,
                        customername: bookingData?.customers?.custname || 'N/A',
                        pendingReceived1: pendingReceived1,
                    });
                }


                // 🟢 Return the combined data including pendingReceived1
                return {
                    ...checkinDetail,
                    booking: bookingData,
                    serviceamount,
                    roomamount: roomamount.toFixed(0),
                    foodamount: foodTotal.toFixed(0),
                    totalamount: totalamount.toFixed(0),
                    alltoal: alltoal.toFixed(0),
                    paidamount: paidAmount.toFixed(0),
                    pending: remaining.toFixed(0),
                    todayDays: dayDifference,
                    paymentHistory,
                    pendingReceived1: pendingReceived1.toFixed(0), // ✅ Added here
                };
            })
        );

        // Update states after loop
        setallllroomamount(allllroomamount.toFixed(0));
        setallllfoodamount(allllfoodamount.toFixed(0));
        setalllltotalamount(alllltotalamount.toFixed(0));
        setallllserviuceamount(allllserviceamount.toFixed(0));
        setroomscount(noofroomscount.toFixed(0));
        settodasypending(todayspending.toFixed(0));
        setpendingReceived(pendingReceived.toFixed(0));
        setalldaytotal((parseFloat(pendingReceived) + parseFloat(alllltotalamount)).toFixed(0));

        // ✅ Now combinedData contains pendingReceived1 per booking
        setbookingData(combinedData);
        setpendinRecieved(pendingReceivedZeroList)



        // Iterate through paymentHistoryData and accumulate totals for paymode1 and paymode2 where bookingId exists in bookingsDataMap
        paymentHistoryData.forEach((payhistoryItem) => {
            const { paymode1, paymode2, amount1, amount2, data } = payhistoryItem;

            // Check if bookingId exists in bookingsDataMap before adding amounts
            if (bookingsDataMap[data.bookingid]) {
                // Accumulate total for paymode1 using amount1
                if (paymode1) {
                    if (!paymentModesTotals[paymode1]) {
                        paymentModesTotals[paymode1] = 0;
                    }
                    paymentModesTotals[paymode1] += amount1;
                }

                // Accumulate total for paymode2 using amount2
                if (paymode2) {
                    if (!paymentModesTotals[paymode2]) {
                        paymentModesTotals[paymode2] = 0;
                    }
                    paymentModesTotals[paymode2] += amount2;
                }
            }
        });

        // Convert paymentModesTotals object to array
        const paymentModesArray = Object.keys(paymentModesTotals).map((paymode) => ({
            paymode,
            totalAmount: paymentModesTotals[paymode]
        }));

        // Set the new payment modes array
        setpaymodes(paymentModesArray);

        let totalSum = 0;
        const receivedPayments = [];

        // Step 1: Convert reportDate to a Date object if necessary
        const reportDateObj = reportDate.toDate ? reportDate.toDate() : new Date(reportDate);

        // Step 2: Define the start and end of the report date
        const startOfDay = new Date(reportDateObj.setHours(0, 0, 0, 0));  // Start of the reportDate
        const endOfDay = new Date(reportDateObj.setHours(23, 59, 59, 999));  // End of the reportDate

        // Step 3: Query bookings where checkoutdate matches reportDate
        const bookingsQuery1 = query(
            collection(db, 'bookings'),
            where('checkoutdate', '==', reportDate),
            where('status', '==', 'Checkout')
        );

        const bookingsSnapshot1 = await getDocs(bookingsQuery1);

        // Fetch payment modes
        const paymentModesSnapshot = await getDocs(collection(db, 'paymentmodes'));
        const paymentModesMap = {};
        paymentModesSnapshot.forEach((doc) => {
            paymentModesMap[doc.id] = doc.data().paymode;
        });

        // Step 4: Fetch payhistory and combine with booking data
        const fetchPayHistoryPromises = bookingsSnapshot1.docs.map(async (doc) => {
            const bookingId = doc.id;
            const bookingData = doc.data();

            // Query payment history where createdAt is within the reportDate range
            const payHistoryQuery = query(
                collection(db, 'payhistory'),
                where('bookingid', '==', bookingId),
                where('createdAt', '>=', Timestamp.fromDate(startOfDay)),
                where('createdAt', '<=', Timestamp.fromDate(endOfDay))
            );

            const payHistorySnapshot = await getDocs(payHistoryQuery);
            let payHistoryTotal = 0;
            const paymentHistory = [];

            // Parallelize payHistory processing
            const payHistoryPromises = payHistorySnapshot.docs.map(async (payDoc) => {
                const payData = payDoc.data();

                payHistoryTotal += (payData.amount1 || 0) + (payData.amount2 || 0);

                // Get paymode1 and paymode2 using the pre-fetched paymentModesMap
                const paymode1 = paymentModesMap[payData.paymode1] || "";
                const paymode2 = paymentModesMap[payData.paymode2] || "";


                // Store each payment history entry
                paymentHistory.push({
                    amount1: payData.amount1 || 0,
                    amount2: payData.amount2 || 0,
                    paymode1: paymode1,
                    paymode2: paymode2,
                    date: payData.createdAt || null  // Assuming 'date' exists in payhistory
                });


            });

            await Promise.all(payHistoryPromises);

            // Only add bookings with payment history and checkindate !== reportDate
            if (payHistorySnapshot.docs.length > 0 && bookingData.checkindate !== reportDate) {
                // Only add payHistoryTotal for bookings that meet the condition
                totalSum += payHistoryTotal;

                receivedPayments.push({
                    bookingId,
                    ...bookingData,  // Spread all booking data fields
                    payHistoryTotal: payHistoryTotal.toFixed(0),
                    paymentHistory  // Attach full payment history to each booking
                });
            }
        });

        await Promise.all(fetchPayHistoryPromises);

        // Step 5: Set the total sum, received payment data, and pendingReceived1
        setcheckoutReceived(totalSum.toFixed(0));  // Set total amount received
        setReceivedPayment(receivedPayments);  // Set received payment data

        setloading(true);
    };


    const handlePrint = useReactToPrint({
        content: () => printRef.current,
    })

    const handlereportDate = (e) => {
        setreportDate(e.target.value)
        setloading(false)
    }


    return (
        <div>
            <Menu />
            <div className="content-wrapper">
                <section className="content mt-2">
                    <div className="container-fluid">
                        <button className="btn btn-secondary " >|| DCR Report ||</button><br /><br />
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card card-primary card-outline">
                                    <div className="card-body">
                                        <div className='row'>
                                            <div className='col-sm-4'>
                                                <label> Date</label>
                                                <input type='date' value={reportDate} onChange={handlereportDate} className='form-control' />
                                            </div>
                                            <div className='col-sm-3'>
                                                <br />
                                                <button className='btn btn-info' onClick={getReport}>Get Report</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {
                                    loading &&
                                    <>
                                        <div className="card card-primary card-outline" ref={printRef}>
                                            <div className="card-body">
                                                <div className="row invoice-info">
                                                    <div className="col-sm-12 invoice-col text-center">
                                                        <address>
                                                            <h4>Dasara Executive</h4>
                                                            Chatrapati Shivaji Maharaj Chouk, Tuljapur, Dist - Dharashiv, MH - 413601<br />
                                                            Phone: +91 9975294940 |
                                                            Email:  dasaraexecutive@gmail.com<br />
                                                            Website:  www.dasaraexecutive.com
                                                        </address>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <table className='customers'>
                                                        <tr>
                                                            <th style={{ textAlign: "center" }}>Report Date : {moment(reportDate).format('DD/MM/YYYY')}  </th>
                                                            <th style={{ textAlign: "center" }}><h5>DCR REPORT </h5></th>
                                                            <th style={{ textAlign: "center" }}>Report Time : {moment().format('DD/MM/YYYY HH:mm:ss A')}</th>
                                                        </tr>
                                                    </table>
                                                    <table className="customers">
                                                        <thead>
                                                            <tr>
                                                                <th>Sr No</th>
                                                                <th>Customer Name </th>
                                                                <th>Checkin Date </th>
                                                                <th>Checkout Date </th>
                                                                <th> Days </th>
                                                                <th>Rooms </th>
                                                                <th style={{ textAlign: "right" }}>Amount </th>
                                                                <th style={{ textAlign: "right" }}>Extra </th>
                                                                {/* <th style={{ textAlign: "right" }}>Food</th> */}
                                                                <th style={{ textAlign: "right" }}>Total</th>
                                                                {/* <th style={{ textAlign: "right" }}>Noofday</th> */}
                                                                <th style={{ textAlign: "center" }}>Payments</th>
                                                                <th>Status</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                [...bookingData]
                                                                    .sort((a, b) => {
                                                                        const dtA = moment(`${a.checkindate} ${a.booking.checkintime}`, 'YYYY-MM-DD HH:mm');
                                                                        const dtB = moment(`${b.checkindate} ${b.booking.checkintime}`, 'YYYY-MM-DD HH:mm');
                                                                        return dtA - dtB;
                                                                    })
                                                                    .map((item, index) => {
                                                                        const totalPaid = item.paymentHistory.reduce((sum, entry) => sum + parseFloat(entry.data.amount1 || 0) + parseFloat(entry.data.amount2 || 0), 0);
                                                                        const remaining = parseFloat(item.totalamount) - parseFloat(totalPaid);
                                                                        return (
                                                                            <tr key={index}>
                                                                                <td width="80">{index + 1}</td>
                                                                                <td style={{ textTransform: "capitalize" }}>{item.booking.customers.custname}</td>
                                                                                <td>{moment(item.checkindate).format('DD/MM/YYYY')} {item.booking.checkintime}</td>
                                                                                <td>{moment(item.checkoutdate).format('DD/MM/YYYY')} {item.booking.checkouttime}</td>
                                                                                <td>1</td>
                                                                                <td>
                                                                                    <div className='row'>
                                                                                        {item.booking.rooms.map((item1, i) =>
                                                                                            <span key={i}>&nbsp; {item1.roomname} ({parseFloat(item1.discount)}%) </span>
                                                                                        )}
                                                                                    </div>
                                                                                </td>
                                                                                <td style={{ textAlign: "right" }}>{item.roomamount}</td>
                                                                                <td style={{ textAlign: "right" }}>{item.serviceamount}</td>
                                                                                {/* <td style={{ textAlign: "right" }}>{item.foodamount}</td> */}
                                                                                <td style={{ textAlign: "right" }}>{item.totalamount}</td>
                                                                                <td style={{ textAlign: "right" }}>
                                                                                    {
                                                                                        item.paymentHistory.length > 0 ?
                                                                                            item.paymentHistory.map((ph, idx) => (
                                                                                                <React.Fragment key={idx}>
                                                                                                    {parseFloat(ph.data.amount1) > 0 &&
                                                                                                        <b>{ph.paymode1} : {parseFloat(ph.data.amount1).toFixed(0)} <br /></b>}
                                                                                                    {parseFloat(ph.data.amount2) > 0 &&
                                                                                                        <b>{ph.paymode2} : {parseFloat(ph.data.amount2).toFixed(0)}<br /></b>}
                                                                                                </React.Fragment>
                                                                                            )) :
                                                                                            <b style={{ color: "red" }}>Pending <br /></b>
                                                                                    }
                                                                                    {remaining > 0 && <b style={{ color: "red" }}>Remaining : {remaining} <br /></b>}
                                                                                </td>
                                                                                <td>
                                                                                    {item.booking.checkindate !== reportDate &&
                                                                                        <b style={{ color: "green" }}>Continued..</b>}
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    })
                                                            }
                                                            <tr>
                                                                <th colSpan={4} style={{ textAlign: "right" }}>TOTAL</th>
                                                                <th>{roomscount}</th>
                                                                <th style={{ textAlign: "right" }}>{allllroomamount}</th>
                                                                <th style={{ textAlign: "right" }}>{allllserviuceamount}</th>
                                                                <th style={{ textAlign: "right" }}>{allllfoodamount}</th>
                                                                <th style={{ textAlign: "right" }}>{alllltotalamount}</th>
                                                                <th></th>
                                                                <th></th>
                                                            </tr>
                                                        </tbody>

                                                    </table>

                                                    <table className='customers' style={{ width: "25%" }}>
                                                        <thead>

                                                            <tr>
                                                                <th>Paymodes</th>
                                                                <th style={{ textAlign: "right" }}>Amount</th>

                                                            </tr>
                                                            {
                                                                paymodes.map((item, index) =>
                                                                    <tr key={index}>
                                                                        <td>{item.paymode}</td>
                                                                        <td style={{ textAlign: "right" }}>{parseFloat(item.totalAmount).toFixed(0)}</td>
                                                                    </tr>
                                                                )
                                                            }
                                                            <tr>
                                                                <td>Pending Amount</td>
                                                                <td style={{ textAlign: "right" }}>{todasypending}</td>

                                                            </tr>
                                                            <tr>
                                                                <td>Total </td>
                                                                <td style={{ textAlign: "right" }}>{alllltotalamount}</td>

                                                            </tr>
                                                            <tr>
                                                                <td>Pending Received</td>
                                                                <td style={{ textAlign: "right" }}>{(parseFloat(pendingReceived)).toFixed(0)}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Checkout Received</td>
                                                                <td style={{ textAlign: "right" }}>{(parseFloat(checkoutReceived)).toFixed(0)}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Total Amount</td>
                                                                <td style={{ textAlign: "right" }}>{(parseFloat(alllltotalamount) + parseFloat(pendingReceived) + parseFloat(checkoutReceived)).toFixed(0)}</td>
                                                            </tr>

                                                        </thead>
                                                    </table>
                                                    <table className="customers">
                                                        <thead>
                                                            <tr>
                                                                <th colSpan={12}>Checkout Received From</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Sr No</th>
                                                                <th>Customer Name </th>
                                                                <th>Checkin Date </th>
                                                                <th>Checkout Date </th>
                                                                <th> Days </th>
                                                                <th>Rooms </th>
                                                                {/* <th style={{ textAlign: "right" }}>Total</th> */}
                                                                <th style={{ textAlign: "center" }}>Payments</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                ReceivedPayment.map((item, num = 1) => {
                                                                    return (
                                                                        <tr key={num + 1}>
                                                                            <td width="80">{num + 1}</td>
                                                                            <td style={{ textTransform: "capitalize" }}>{item.customers.custname}</td>
                                                                            <td>{moment(item.checkindate).format('DD/MM/YYYY')} {item.checkintime}</td>
                                                                            <td>{moment(item.checkoutdate).format('DD/MM/YYYY')} {item.checkouttime}</td>
                                                                            <td> {item.noofdays}</td>
                                                                            <td>
                                                                                {item.rooms.map((item1, index) =>
                                                                                    <span key={index}>&nbsp; {item1.roomname}  ({parseFloat(item1.discount)}%)<br /> </span>
                                                                                )}
                                                                            </td>
                                                                            {/* <td style={{ textAlign: "right" }}>{item.totalamount.toFixed(0)}</td> */}
                                                                            <td style={{ textAlign: "right" }}>
                                                                                {
                                                                                    item.paymentHistory.map((itemmm, index) =>
                                                                                        <>
                                                                                            {
                                                                                                parseFloat(itemmm.amount1) > 0 &&
                                                                                                <b>{itemmm.paymode1} : {parseFloat(itemmm.amount1).toFixed(0)} <br /></b>
                                                                                            }
                                                                                            {
                                                                                                parseFloat(itemmm.amount2) > 0 &&
                                                                                                <b>{itemmm.paymode2} : {parseFloat(itemmm.amount2).toFixed(0)}</b>
                                                                                            }
                                                                                        </>
                                                                                    )
                                                                                }
                                                                            </td>

                                                                        </tr>
                                                                    )
                                                                }
                                                                )}

                                                        </tbody>
                                                    </table>
                                                    <table className="customers">
                                                        <thead>
                                                            <tr>
                                                                <th colSpan={12}>Pending Received From</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Sr No</th>
                                                                <th>Customer Name </th>
                                                                <th>Amount </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                pendinRecieved.map((item, num = 1) => {
                                                                    return (
                                                                        <tr key={num + 1}>
                                                                            <td width="80">{num + 1}</td>
                                                                            <td style={{ textTransform: "capitalize" }}>{item.customername}</td>
                                                                            <td> {item.pendingReceived1.toFixed(2)}</td>
                                                                        </tr>
                                                                    )
                                                                }
                                                                )}

                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                        </div>
                                        <center>
                                            <button className='btn btn-success' onClick={handlePrint}>Print Report</button>
                                        </center>
                                    </>
                                }

                            </div>
                        </div>
                    </div>
                </section >

            </div>
        </div >

    )
}

export default Dcrreport
